import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const updateFhirJson = async (foi = null, resourceJson = null, title = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!foi || !resourceJson || !title) {
        console.log("missing foi, resourceJson, or title");
        return null;
    }
    console.log("CALLING SERVER with updatefhirresource")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "updatefhirresource",
            "fhirEntry": JSON.stringify(resourceJson, null, 2),
            "apiToken": apiToken,
            "resourcetype": resourceJson.resourceType,
            "resourceid": foi,
            "title": title,
            "status": "active",
            "bypasswarnings": true
        },
    })
};

export default updateFhirJson;